import { render, staticRenderFns } from "./gdt-task-card.vue?vue&type=template&id=34d994bd&scoped=true&lang=pug&"
import script from "./gdt-task-card.vue?vue&type=script&lang=js&"
export * from "./gdt-task-card.vue?vue&type=script&lang=js&"
import style0 from "./gdt-task-card.vue?vue&type=style&index=0&id=34d994bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d994bd",
  null
  
)

export default component.exports